import React from "react";
import Input from "./Input";

function formatDateToInput(date) {
    if (!date || isNaN(date.getTime())) return "";
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
}

class DatePicker extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: this.props.value ? this.props.value : "",
            isChangeByUser: false,
            now: new Date()
        }
        this.onDatePickerChange = this.onDatePickerChange.bind(this);
    }

    componentDidMount() {
        var value = this.props.value;
        const re = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/;
        if (value && value.match(re)) {
            this.setState({ value });
        } else {
            const date = value ? new Date(value) : null;
            const formatted = formatDateToInput(date);
            this.setState({ value: formatted });
        }
    }

    onDatePickerChange(value) {
        this.setState({ isChangeByUser: true })
        this.props.onChange(value);
        this.setState({ value });
    }
    render() {
        var { onChange, value, ...newProps } = this.props;
        const minDate = formatDateToInput(new Date(this.state.now.getFullYear() - 1000, this.state.now.getMonth(), this.state.now.getDate()));
        const maxDate = this.props.id?.includes("naissance") ? "2010-01-01" : formatDateToInput(new Date(this.state.now.getFullYear() + 1000, this.state.now.getMonth(), this.state.now.getDate()));
        return (
            <Input type="date" min={minDate} max={maxDate} onChange={this.onDatePickerChange} value={this.state.value} {...newProps} />
        )
    }
}

export default DatePicker;